import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom'
import { SnackbarProvider, useSnackbar } from 'notistack';
import { Box, IconButton, createTheme } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

import HomeLayout from './layouts/HomeLayout';
import Signin from './pages/accounts/Signin';
import Signup from './pages/accounts/Signup';
import Activate from './pages/accounts/Activate';
import Resend from './pages/accounts/Resend';
import ResetPassword from './pages/accounts/ResetPassword';
import NotFound from './pages/errorpages/NotFound';
import InternalServerError from './pages/errorpages/InternalServerError';
import MainLayout from './layouts/MainLayout';
import Homepage from './pages/Homepage';
import JobsHome from './pages/job/JobsHome';
import Reportpage from './pages/Reportpage';
import Invoicepage from './pages/Invoicepage';
import Subscription from './pages/Subscription';
import PhotoSettings from './pages/photosettings/PhotoSettings';
import Storage from './pages/storage/Storage';
import Transaction from './pages/transaction/Transaction';
import ProfilePage from './pages/accounts/ProfilePage';
import Services from './pages/services/Services';
import JobPage from './pages/job/JobPage';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Createjob from './pages/job/create/Createjob';
import Report from './pages/report/Report';
import { alertMsg } from './utils/basicUtils';
import ForgotPassword from './pages/accounts/ForgotPassword';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

const SnackbarCloseButton = ({ snackbarKey }) => {
    const { closeSnackbar } = useSnackbar();
    return (
        <IconButton onClick={() => closeSnackbar(snackbarKey)}>
            <CloseOutlinedIcon color="action" sx={{ fontSize: '20px' }} />
        </IconButton>
    );
}

const App = () => {
    const current_theme = useSelector(state => state.ui.isDarkMode)
    const theme = createTheme({
        palette: {
            mode: current_theme ? 'dark' : 'light',
            ...(
                current_theme ?
                    {
                        // Dark theme color
                        primary: {
                            light: "#7986cb",
                            main: "#3f51b5",
                            dark: "#303f9f",
                            contrastText: "#fff"
                        },
                        background: {
                            card: "#5a5a5a",
                            primary: "#3f51b5",
                            sidebar: "#1e1e1e",
                            secondary: "#D0D1FF",
                            stripped: "#707070",
                            dark: "#121212",
                            selected: "#D0D1FF"
                        },
                        text: {
                            title: "#fff",
                        },
                        custom: {
                            border: "#8a9cff",
                        }
                    } :

                    {
                        // Light theme color
                        primary: {
                            light: "#7986cb",
                            main: "#0B1345",
                            dark: "#0B1345",
                            contrastText: "#fff"
                        },
                        secondary: {
                            light: "#7986cb",
                            main: "#f764a3",
                            dark: "#303f9f",
                        },
                        background: {
                            default: "#f6f8ffbf",
                            card: "#fff",
                            primary: "#0B1345",
                            secondary: "#f764a3",
                            sidebar: "#d4d9ff",
                            stripped: "#f7f7f7",
                            light: "#f6f6f6",
                            selected: "#D0D1FF"
                        },
                        text: {
                            title: "#3f51b5",
                        },
                        custom: {
                            border: "#8a9cff",
                        }
                    }
            )

        },
        typography: {
            fontFamily: [
                'Poppins',
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            // body1: {
            //     fontWeight: 500,
            // }
        },
    });



    return (
        <SnackbarProvider maxSnack={3} action={snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey} />} >
            <ThemeProvider theme={theme}>
                <Box className={current_theme ? 'dark-mode' : 'light-mode'}>
                    <Routes >
                        <Route element={<HomeLayout />}>
                            <Route path="accounts/*">
                                <Route path="signin" element={<Signin />} />
                                <Route path='forgot_password' element={<ForgotPassword />} />
                                <Route path="signup" element={<Signup />} />
                                <Route path="activate" element={<Activate />} />
                                <Route path="resend" element={<Resend />} />
                                <Route path="reset_password" element={<ResetPassword />} />
                                <Route path="*" element={<NotFound />} />
                            </Route>
                        </Route>
                        {process.env.NODE_ENV === "development"
                            &&
                            <Route path="exp/*">
                                <Route path="*" element={<NotFound />} />
                            </Route>
                        }
                        <Route errorElement={<InternalServerError />} element={<MainLayout />}>
                            <Route path="/" index={true} element={<Homepage />} />
                            <Route path="/jobs" element={<JobsHome />} />
                            <Route path="/reports" element={<Reportpage />} />
                            <Route path="/invoices" element={<Invoicepage />} />
                            <Route path="/wallet" element={<Subscription />} />
                            <Route path="/jobs/:id" element={<JobPage />} />
                            <Route path="/jobs/create/:draftId" element={<Createjob />} />
                            <Route path="/photosettings" element={<PhotoSettings />} />
                            <Route path="/storage" element={<Storage />} />
                            <Route path="/transaction" element={<Transaction />} />
                            <Route path="/report" element={<Report />} />
                            <Route path="accounts/*">
                                <Route path="profile" element={<ProfilePage />} />
                            </Route>
                            <Route path="/services/*">
                                <Route index={true} element={<Services />} />
                                <Route path="*" element={<NotFound />} />
                            </Route>
                        </Route>
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Box>
            </ThemeProvider>
        </SnackbarProvider>
    );
}

export default App;